import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { ArrowUpRight } from "lucide-react";
import { OfferedServices } from "@/lib/types";
import { cn } from "@/lib/utils/utils";
interface ServiceDeckCardProps {
  data: OfferedServices;
  /** Card ground. Comes from the deck so the four cards read as one palette. */
  tone: string;
  duration: string;
  lead: string;
  tools: string[];
  className?: string;
}
const ServiceDeckCard = t0 => {
  const $ = _c(36);
  const {
    data,
    tone,
    duration,
    lead,
    tools,
    className
  } = t0;
  const t1 = `/services/${data.slug}`;
  const t2 = `View the ${data.title} service`;
  let t3;
  if ($[0] !== tone) {
    t3 = {
      background: tone
    };
    $[0] = tone;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== className) {
    t4 = cn("group flex h-full w-full flex-col gap-5 overflow-hidden rounded-3xl p-6 text-card-foreground md:p-8 lg:gap-6 lg:p-10", className);
    $[2] = className;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== data.id) {
    t5 = <span className="font-mono text-xs font-bold tracking-[0.3em]">{data.id}</span>;
    $[4] = data.id;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <br />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== duration || $[8] !== lead) {
    t7 = <span className="text-right font-mono text-[10px] leading-relaxed tracking-[0.2em] uppercase opacity-60">{duration}{t6}{lead}</span>;
    $[7] = duration;
    $[8] = lead;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t5 || $[11] !== t7) {
    t8 = <div className="flex items-start justify-between gap-4">{t5}{t7}</div>;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== data.title) {
    t9 = <h3 className="text-3xl leading-[0.86] font-black tracking-tighter uppercase md:text-5xl xl:text-6xl">{data.title}</h3>;
    $[13] = data.title;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== data.description) {
    t10 = <p className="max-w-3xl text-sm leading-relaxed opacity-75 md:text-base">{data.description}</p>;
    $[15] = data.description;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== data.subFeatures) {
    t11 = data.subFeatures.map(_temp2);
    $[17] = data.subFeatures;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t11) {
    t12 = <div className="grid flex-1 grid-cols-2 content-start gap-x-5 gap-y-4 md:grid-cols-4 md:gap-6">{t11}</div>;
    $[19] = t11;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== tools) {
    t13 = tools.map(_temp3);
    $[21] = tools;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="ml-auto inline-flex items-center gap-1.5 border-b-2 border-card-foreground pb-0.5 text-sm font-black tracking-tight uppercase">View service<ArrowUpRight className="size-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={2.4} /></span>;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t13) {
    t15 = <div className="flex flex-wrap items-center gap-2 border-t border-black/20 pt-4">{t13}{t14}</div>;
    $[24] = t13;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t1 || $[27] !== t10 || $[28] !== t12 || $[29] !== t15 || $[30] !== t2 || $[31] !== t3 || $[32] !== t4 || $[33] !== t8 || $[34] !== t9) {
    t16 = <Link href={t1} aria-label={t2} style={t3} className={t4}>{t8}{t9}{t10}{t12}{t15}</Link>;
    $[26] = t1;
    $[27] = t10;
    $[28] = t12;
    $[29] = t15;
    $[30] = t2;
    $[31] = t3;
    $[32] = t4;
    $[33] = t8;
    $[34] = t9;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
};
export default ServiceDeckCard;
function _temp(point) {
  return <li key={point} className="text-xs leading-tight font-black tracking-tight uppercase md:text-sm">{point}</li>;
}
function _temp2(group) {
  return <div key={group.title}><h4 className="mb-2.5 font-mono text-[9px] font-bold tracking-[0.2em] uppercase opacity-60">{group.title}</h4><ul className="space-y-1.5">{group.points.map(_temp)}</ul></div>;
}
function _temp3(tool) {
  return <span key={tool} className="rounded-full border border-black/30 px-2.5 py-1.5 font-mono text-[9px] font-bold tracking-[0.14em] uppercase">{tool}</span>;
}